<div class="extra-results-attributes">
  <clr-tree>
    <clr-tree-node
      [(clrExpanded)]="dcdResultsExpanded"
      *ngFor="let attribute of dcdSpecifications | resultsHeader: true"
    >
      {{ attribute.longName }}
      <clr-tree-node
        *ngFor="let attribute of activeDcdAttributes | resultsHeader: false"
      >
        <div class="child-long-name">
          {{ attribute.longName }}
        </div>
      </clr-tree-node>
    </clr-tree-node>
  </clr-tree>
</div>
